import React from 'react'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiBook, FiSettings, FiLogOut } = FiIcons

const Header = ({ isAuthenticated, onLogout, onRequestAuth }) => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <SafeIcon icon={FiBook} className="text-white text-xl" />
            </div>
            <div>
              <h1 style={{
      color: 'rgb(17, 24, 39)'
    }} className="text-xl font-semibold text-gray-900">Quran For All, NurulQuran Norway</h1>
              <p style={{
      color: 'rgb(107, 114, 128)'
    }} className="text-sm text-gray-500">Never miss a lesson on your journey of learning.</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <button
                onClick={onLogout}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <SafeIcon icon={FiLogOut} className="text-lg" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            ) : (
              <button
                onClick={onRequestAuth}
                className="flex items-center space-x-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
              >
                <SafeIcon icon={FiSettings} className="text-lg" />
                <span className="hidden sm:inline">Admin</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header